export default function Payment({ data }) {
  return (
    <div>
      <h2 className="text-yellow-200 mb-3">Payments</h2>

      {data?.payments?.map((p, i) => (
        <div key={i} className="bg-gray-800 p-2 mb-2 rounded">
          {p.farmer} → ₹{p.amount} ({p.status})
        </div>
      ))}
    </div>
  );
}